import { CONCIERGE_PATHNAME } from 'site-modules/canvas/constants/concierge';

export const isConciergePage = location => location?.pathname === CONCIERGE_PATHNAME;
